import { render, staticRenderFns } from "./confBtn.vue?vue&type=template&id=f893e99a&scoped=true&lang=pug&"
import script from "./confBtn.vue?vue&type=script&lang=js&"
export * from "./confBtn.vue?vue&type=script&lang=js&"
import style0 from "./confBtn.vue?vue&type=style&index=0&id=f893e99a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f893e99a",
  null
  
)

export default component.exports